import { Tab } from '@mui/material';
import { Fragment, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { PageHeader, QueryTabs, QueryTabPanel } from 'components';
import { NEW_ID } from 'constants/common.constants';
import { ROUTE_PATH } from 'constants/routes';
import { useQueryTab, useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { BlockedCustomersList } from './BlockedCustomersList';

enum Tabs {
  Active = 'active',
  Archive = 'archive',
}

export const BlockedCustomersPage: React.FC = () => {
  const { t: tLayout } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'layout',
  });
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.blocked_customers',
  });

  const { isAdmin, isTechOperator } = useUser();
  const navigate = useNavigate();
  const { tab } = useQueryTab<Tabs>();

  const detailsUrl = useMemo(() => {
    if (isAdmin) {
      return ROUTE_PATH.ADMIN.BLOCKED_CUSTOMERS_DETAILS;
    }
    if (isTechOperator) {
      return ROUTE_PATH.TECH_OPERATOR.BLOCKED_CUSTOMERS_DETAILS;
    }
    return undefined;
  }, [isAdmin, isTechOperator]);

  const handleCreate = useCallback(
    () => navigate(generatePath(detailsUrl!, { id: NEW_ID })),
    [detailsUrl, navigate],
  );

  return (
    <Fragment>
      <PageHeader
        title={tLayout('menu_items.customers')}
        divider={false}
        {...(tab === Tabs.Active && {
          rightContentButton: { onClick: handleCreate },
        })}
      />
      <QueryTabs tabsEnum={Tabs}>
        <Tab value={Tabs.Active} label={t('tabs.active')} />
        <Tab value={Tabs.Archive} label={t('tabs.archive')} />
      </QueryTabs>
      <QueryTabPanel value={Tabs.Active}>
        <BlockedCustomersList />
      </QueryTabPanel>
      <QueryTabPanel value={Tabs.Archive}>
        <BlockedCustomersList archived />
      </QueryTabPanel>
    </Fragment>
  );
};
